import Component from "./news"

export default Component 
